import React, { useContext, useEffect, useState } from 'react';
import { Col, Card, Navbar, Nav } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";

import axios from 'axios';
import { site_url } from "./../config.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { useLocation } from 'react-router-dom';
import { AuthContext } from './../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';
import { formatBonusAmount, parseWalletAmount } from '../parseWalletAmount.js';
import { FormatDate } from '../Function';

function Index() {
  const { user } = useContext(AuthContext);
  const [data, setdata] = useState([]);
  const location = useLocation();

  const formatBonusType = (typeValue) => {
    if (!typeValue) return "";

    return String(typeValue)
      .replace(/_slug/gi, "")
      .replace(/_/g, " ")
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const statusLabel = (shop) => {
    const status = String(shop.overflow_status || shop.status || '').toLowerCase();
    if (status === 'returned') return 'Returned';
    if (status === 'expired') return 'Expired';
    return 'Pending';
  };

  useEffect(() => {
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }, [location]);

  const goBack = () => {
    window.history.back();
  };

  useEffect(() => {
    getUserdetails();
  }, [user]);

  const getUserdetails = async () => {
    const token = parseStoredAccessToken(user);
    if (!token) {
      return;
    }

    axios.get(site_url + "/allsuspended_account", {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json'
      }
    })
      .then(res => {
        if (res.data.status === 'success') {
          const rows = Array.isArray(res.data.wallet) ? res.data.wallet : [];
          setdata(rows.filter((row) => row.is_overflow !== false));
        }
      })
      .catch(err => {
        console.error("API Error:", err.response?.data || err);
      });
  };

  return (
    <div>
      <div className="min-vh-100">
        <Navbar expand="lg" className="navbar px-3">
          <Navbar.Brand className="fw-bold text-white">
            <center>
              <FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> Overflow Account
            </center>
          </Navbar.Brand>
          <Nav className="ms-auto d-flex align-items-center"></Nav>
        </Navbar>
        <div className="row justify-content-center mt-2 p-2">
          {(!data || data.length === 0) && (
            <div className="col-12 p-3 text-center text-muted">
              No overflow account entries yet.
            </div>
          )}
          {data.map((shop, index) => (
            <div className="col-12 p-1" key={shop.id || index}>
              <Col xs={12} className="">
                <Card>
                  <Card.Body>
                    <div className='row'>
                      <div className='col-4'>
                        <center><img src={'./wallet.png'} className="shoplist_img" alt="" /></center>
                      </div>
                      <div className='col-8'>
                        <h3>
                          <span className="shoplist_text">Bonus Coins {formatBonusAmount(shop)}</span>
                        </h3>
                        <p className="shoplist_dcr">Status : {statusLabel(shop)}</p>
                        {shop.available_amount != null && (
                          <p className="shoplist_dcr">
                            Remaining : Reward Points.{parseWalletAmount(shop.available_amount).toFixed(2)}
                          </p>
                        )}
                        <p className="shoplist_dcr">Date : {FormatDate(shop.created_at)}</p>
                        <p className="shoplist_dcr">Type : Overflow Account{shop.bonus_type ? ` (${formatBonusType(shop.bonus_type)})` : ''}</p>
                        {shop.expires_at && (
                          <p className="shoplist_dcr">Expiry : {FormatDate(shop.expires_at)}</p>
                        )}
                        {shop.return_date && statusLabel(shop) === 'Pending' && (
                          <p className="shoplist_dcr" style={{ color: '#b45309', fontWeight: 600 }}>
                            Returns on : {FormatDate(shop.return_date)}
                          </p>
                        )}
                        {shop.billno && (
                          <p className="shoplist_dcr">Bill Number: {shop.billno} <br></br> <b className="text-danger">Bill Amount:₹{shop.totalbillamount}</b></p>
                        )}
                        {shop.notes && (
                          <p className="shoplist_dcr" style={{ color: '#b45309', fontWeight: 600 }}>
                            Notes : {shop.notes}
                          </p>
                        )}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Index;
